import React from "react";
import "./LoadingBar.scss";
import { ReactComponent as LoadingIcon } from "../../../assets/icons/loading-icon.svg";
import { Stack } from "@mui/material";

const LoadingComponent = ({ message = "Loading..." }) => {
  return (
    <Stack
      direction={"row"}
      useFlexGap
      gap={1}
      alignItems={"center"}
      className="loading-container"
    >
      <LoadingIcon className="loading-icon" />
      <span className="loading-text">{message}</span>
    </Stack>
  );
};

export default LoadingComponent;
